import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { runtimeConfig } from "@/shared/config/runtime";

export function readOneCBaseUrl(): string {
  const config = runtimeConfig.oneCAccounting;
  return config.enabled && config.source === "remote" ? config.baseUrl : "";
}

function readOrigin(url: string): string {
  try {
    return new URL(url, window.location.origin).origin;
  } catch {
    return "";
  }
}

export function isOneCSameOrigin(baseUrl: string): boolean {
  if (!baseUrl) return false;
  const target = readOrigin(baseUrl);
  if (!target) return false;
  return target === readOrigin(runtimeConfig.apiUrl) || target === window.location.origin;
}

export function readOneCCredentials(): RequestCredentials {
  return isOneCSameOrigin(readOneCBaseUrl()) ? "include" : "omit";
}

const rawOneCQuery = fetchBaseQuery({
  baseUrl: readOneCBaseUrl(),
  credentials: readOneCCredentials(),
  prepareHeaders(headers) {
    if (isOneCSameOrigin(readOneCBaseUrl())) {
      headers.set("ngrok-skip-browser-warning", "true");
    }
    return headers;
  },
});

function buildDisabledError(): FetchBaseQueryError {
  return { status: 400, data: { detail: "one_c_accounting_disabled" } };
}

export const oneCBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async function (
  args,
  api,
  extraOptions,
) {
  if (!runtimeConfig.oneCAccounting.enabled) return { error: buildDisabledError() };
  return rawOneCQuery(args, api, extraOptions);
};
